/**
 * Shared constants and helpers for the Media page feature.
 * Importing from here ensures a single source of truth across all
 * sub-components (MediaPage, MediaTable, etc.).
 */

export const MEDIA_TYPE_LABELS = {
  LOGO: 'Logo',
  FOOTER: 'Footer',
  TERMS_AND_CONDITIONS: 'T&C',
}

export const formatMediaType = (mediaType) => MEDIA_TYPE_LABELS[mediaType] ?? mediaType
